import getAccountErrorMessage from "@saleor/utils/errors/account";

export function useAccountValidation(initialForm, isRunnerRider = false) {
  const {
    firstName,
    lastName,
    contactNo,
    email,
    companyName,
    streetBrgy,
    provinceCode,
    city,
    postalCode
  } = initialForm;

  const firstNameMessage = () => {
    if (firstName === "") {
      return "This field should not be empty.";
    }

    return null;
  };

  const lastNameMessage = () => {
    if (lastName === "") {
      return "This field should not be empty.";
    }
    return null;
  };

  const contactNoMessage = () => {
    if (contactNo === "") {
      return "This field should not be empty.";
    } else if (contactNo.length < 12 || contactNo.length > 12) {
      return "Contact number should have 12 numbers.";
    }

    return null;
  };

  const emailMessage = () => {
    if (email === "") {
      return "This field should not be empty.";
    }

    return null;
  };

  const companyNameMessage = () => {
    if (isRunnerRider === true && companyName === "") {
      return "This field should not be empty.";
    }

    return null;
  };
  const streetBrgyMessage = () => {
    if (isRunnerRider === true && streetBrgy === "") {
      return "This field should not be empty.";
    }

    return null;
  };
  const provinceCodeMessage = () => {
    if (isRunnerRider === true && provinceCode === "") {
      return "This field should not be empty.";
    }

    return null;
  };
  const cityMessage = () => {
    if (isRunnerRider === true && city === "") {
      return "This field should not be empty.";
    }

    return null;
  };
  const postalCodeMessage = () => {
    if (isRunnerRider === true && postalCode === "") {
      return "This field should not be empty.";
    }

    return null;
  };

  return {
    city: cityMessage(),
    companyName: companyNameMessage(),
    contactNo: contactNoMessage(),
    email: emailMessage(),
    firstName: firstNameMessage(),
    lastName: lastNameMessage(),
    postalCode: postalCodeMessage(),
    provinceCode: provinceCodeMessage(),
    streetBrgy: streetBrgyMessage()
  };
}

export const checkError = (key, formErrors, validationError, intl) => {
  const message = formErrors[key]
    ? formErrors[key].message
    : getAccountErrorMessage(formErrors[key], intl);
  return {
    hasError: !!formErrors[key] || !!validationError[key],
    message: formErrors[key] ? message : validationError[key]
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
